import { FormControl, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { BorderedInputAdornment } from '~/modules/@shared/components';
import { text } from '~/modules/@shared/helpers/text';
import { TakePaymentFormData } from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';

export default function PaymentAmountField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<TakePaymentFormData>();

  const name = 'amount';

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormControl fullWidth>
          <TextField
            type="number"
            {...field}
            InputProps={{
              startAdornment: <BorderedInputAdornment position="start">$</BorderedInputAdornment>,
              inputProps: {
                min: 0,
                step: '0.01',
              },
            }}
            error={!!errors.amount}
            helperText={text(errors.amount?.message)}
            FormHelperTextProps={{ error: true }}
          />
        </FormControl>
      )}
    />
  );
}
